module.exports = __webpack_public_path__ + "media/images/flags/64/Poland-c3ac5e22f1ab23bd0fbd0302934ecf29.png";